module.exports = __webpack_public_path__ + "img/content7.2d5693e3.png";